import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { ToolContext } from "../fluent/hoc/fluentToolWrapper";
import { DraggableLine } from "../fluent/primitives/draggable";
export const DraggableLineComponent = (props) => {
    const { useFluent } = useContext(ToolContext);
    if (useFluent) {
        // When updating the callsites to use fluent directly this label will be clearer since the string replace occurs where the Block_Foo lives where the Block name is
        return _jsx(DraggableLine, { ...props, label: props.data.replace("Block", "") });
    }
    return (_jsx("div", { className: "draggableLine", title: props.tooltip, draggable: true, onDragStart: (event) => {
            event.dataTransfer.setData(props.format, props.data);
        }, children: props.data.replace("Block", "") }));
};
//# sourceMappingURL=draggableLineComponent.js.map